import React, { Component, createRef } from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'

import Msg from '../../../i18n/Msg.jsx'

import SmartMenuList from './SmartMenuList'
import NavigationActions from '../actions/NavigationActions'
import NavigationStore from '../stores/NavigationStore'

class SmartMenuItem extends Component {
  constructor(props) {
    super(props)
    const config = window.SMARTADMIN_GLOBALS || {}
    this.menuSpeed = config.menu_speed || 200
    this.liRef = createRef()
  }

  componentDidMount() {
    this._navUnsub = NavigationStore.listen(data => this._handleNav(data))
  }

  componentWillUnmount() {
    if (this._navUnsub) this._navUnsub()
  }

  shouldComponentUpdate() {
    return false
  }

  _handleNav(data) {
    const item = this.props.item
    // Do NOT call updateActive() here — the URL hasn't changed yet because
    // React Router's navigate() fires AFTER the onClick handler. updateActive()
    // is called inside the setTimeout callbacks so it reads the correct URL.
    if (data.item._id === item._id) {
      if (item.isOpen) {
        this._close()
      } else {
        this._open()
      }
    } else if (!item.isParentOf(data.item) || item.isSibling(data.item)) {
      this._close()
    }
  }

  _handleClick = () => {
    NavigationActions.activate(this.props.item)
  }

  _open() {
    this.props.item.isOpen = true
    this._getChildrenListNode().slideDown(this.menuSpeed)
    setTimeout(() => {
      this.props.item.updateActive() // URL is now updated by React Router
      this.forceUpdate()
    }, this.menuSpeed)
  }

  _close() {
    this.props.item.isOpen = false
    this._getChildrenListNode().slideUp(this.menuSpeed)
    setTimeout(() => {
      this.props.item.updateActive() // URL is now updated by React Router
      this.forceUpdate()
    }, this.menuSpeed)
  }

  _getChildrenListNode() {
    return $(this.liRef.current).find('>ul')
  }

  render() {
    const item = this.props.item

    const title = !item.parent
      ? <span className="menu-item-parent">
          <Msg phrase={item.title} />
        </span>
      : <Msg phrase={item.title} />
    const badge = item.badge
      ? <span className={item.badge.class}>
          {item.badge.label || ''}
        </span>
      : null
    const childItems = item.items
      ? <SmartMenuList
          style={{
            display: item.isOpen ? 'block' : 'none'
          }}
          isTop={false}
          items={item.items}
        />
      : null

    const icon = item.icon
      ? item.counter
        ? <i className={item.icon}>
            <em>
              {item.counter}
            </em>
          </i>
        : <i className={item.icon} />
      : null

    const collapseSign = item.items
      ? item.isOpen
        ? <b className="collapse-sign">
            <em className="fa fa-minus-square-o" />
          </b>
        : <b className="collapse-sign">
            <em className="fa fa-plus-square-o" />
          </b>
      : null

    const link = item.route
      ? <Link to={item.route} title={item.title} onClick={this._handleClick}>
          {icon} {title} {badge}
        </Link>
      : <a
          href={item.href || '#'}
          onClick={this._handleClick}
          title={item.title}
        >
          {icon} {title} {badge}
          {collapseSign}
        </a>

    const itemClasses = classnames({
      open: item.isOpen && !!item.items, // only add 'open' on items that have a submenu
      active: item.isActive
    })

    return (
      <li className={itemClasses} ref={this.liRef}>
        {link}
        {childItems}
      </li>
    )
  }
}

export default SmartMenuItem
